import * as React from 'react';
import { useState } from 'react';
import Input from '../../../../../components/Input/Input';
import { useAppDispatch, useAppSelector } from '../../../../../reduxService/hooks';
import { selectProject } from '../../../selector/conversion';
import { setGeometry } from '../../../store/project/projectSlice';
import { IChannelGeometryProps, IChannelGeometrySteppedWeirForm } from './IChannelGeometry';
import { useTranslation } from 'react-i18next';
import { cleanResults } from '../../../store/project/resultsSlice';
import { selectProjectInfo } from '../../../../store/projectInfo/projectInfoSlice';
import { conversionLabel } from '../../../../conversion';
import { warning } from '../../../../../components/Alert/Alert';

const ChannelGeometrySteppedWeir = (props: IChannelGeometryProps) => {
    let timer = React.useRef<NodeJS.Timeout | null>(null);
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const project = useAppSelector(selectProject);
    const projectInfo = useAppSelector(selectProjectInfo);

    const defaultValue: IChannelGeometrySteppedWeirForm = {
        bankTopElevation: project.data!.geometry!.bankTopElevation,
        channelWidth: project.data!.geometry!.channelWidth,
        materialId: project.data?.geometry?.materialId,
        id: project.data?.geometry?.id,
    };
    const [form, setForm] = useState<IChannelGeometrySteppedWeirForm>(defaultValue);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let name = e.target.name;
        let value = parseFloat(e.target.value);

        if (value < 0) {
            value = 0;
            warning(t('warning_not_be_lower', { value: 0 }));
        }

        setForm({
            ...form!,
            [name]: value,
        });
    };

    React.useEffect(() => {
        if (timer.current) {
            clearTimeout(timer.current);
        }
        timer.current = setTimeout(() => {
            dispatch(cleanResults());
            dispatch(setGeometry(form as IChannelGeometrySteppedWeirForm));
        }, 1000);
    }, [form]);

    return (
        <div className='d-flex flex-column gap-2'>
            <Input
                type='number'
                title={t('input_bankTopElevation', { unit_measure: conversionLabel.m_ft[projectInfo.data?.unitOfMeasure as number] })}
                defaultValue={form.bankTopElevation}
                name='bankTopElevation'
                className='d-flex justify-content-between align-items-center'
                onChange={handleInputChange}
            />
            <Input
                type='number'
                title={t('input_channelWidth', { unit_measure: conversionLabel.m_ft[projectInfo.data?.unitOfMeasure as number] })}
                defaultValue={form.channelWidth}
                name='channelWidth'
                className='d-flex justify-content-between align-items-center'
                onChange={handleInputChange}
            />
        </div>
    );
};

export default ChannelGeometrySteppedWeir;
